import { useAppSelector } from '../redux-hooks';
import { getDSCWithTheme } from '../selectors';

export const useVisualizationColors = () =>
  useAppSelector(getDSCWithTheme).visualizationColors;
